import { CallingTheme, lightTheme } from "@azure/communication-react";
import { PartialTheme } from "@fluentui/react";

export const chatTeamsLightTheme: PartialTheme & CallingTheme = {
	...lightTheme,
	palette: {
		...lightTheme.palette,
		themeLight: "#e8ebfa",
		themePrimary: "#5b5fc7"
	},
};
